import { message } from 'antd';
import { setSpinProps } from '../utils';
import { getRealPatrolList, getItemInfo } from '../services/field';
// import { getCurrentBreadCrumbs } from '@/utils/utils';

const initState = {
  targetList: [],
  totalElements: '',
  totalPages: '',

  index: '',
  self: '',
  evaluateList: [],

  spinProps: {
    spinning: false,
    tip: '加载中...',
  },
}

export default {
  namespace: 'field',
  state: initState,

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { targetList, totalElements, totalPages } = yield call(getRealPatrolList, payload);

        yield setSpinProps({ put, rest: {
          targetList,
          totalElements,
          totalPages,
        }});

      } catch (error) {
        yield setSpinProps({ put });
        // message.error(error.msg || '网络错误，请重试');
      }
    },
    *fetchTreeDetail({ payload, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { self, index, evaluateList } = yield call(getItemInfo, payload);

        yield setSpinProps({ put, rest: {
          index,
          self,
          evaluateList,
        } })
        if(callback) {
          callback()
        }
      } catch (error) {
        yield setSpinProps({ put });
        // message.error(error.msg || '网络错误，请重试');
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    }
  }
}